import AccountPauseConfirmPage from './AccountPauseConfirmPage'

export default AccountPauseConfirmPage
// eslint-disable-next-line import/export
export * from './AccountPauseConfirmPage'
